export default __webpack_public_path__ + "static/media/carousel-slide-1.08e65739.jpg";